import url from '@/url.js'
import emptyImage from "@/assets/images/elements/empty.png";

export default {
	methods: {
		alphabetically(v){
			return v.sort(function (a, b) {
				return a.localeCompare(b);
			  });
		},
		getPathFoto(v){
			return v.file !== null ? v.file.includes(`${url.baseFl}/`) ? v.file.split(`${url.baseFl}/`)[1] : v.file : null
		},
		richtTextFormat(text){
			return text.replaceAll("&lt;", "<")
			.replaceAll("&gt;", ">").replaceAll("&amp;lt;", "<").replaceAll("&amp;gt;", ">");
		},
		stringToHTML(str) {
			var parser = new DOMParser();
			var doc = parser.parseFromString(str, 'text/html');
			return doc.body;
		},
		onlyNumber($event) {
			//console.log($event.keyCode); //keyCodes value
			const keyCode = $event.keyCode ? $event.keyCode : $event.which;
			if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
			  // 46 is dot
			  $event.preventDefault();
			}
		},
		
		formatRupiah(angka, prefix = undefined) {
			if(angka != undefined) {
				var number_string = angka.toString().replace(/[^,\d]/g, '').toString(),
				split   		= number_string.split(','),
				sisa     		= split[0].length % 3,
				rupiah     		= split[0].substr(0, sisa),
				ribuan     		= split[0].substr(sisa).match(/\d{3}/gi),
				separator = ''
	 
				// tambahkan titik jika yang di input sudah menjadi angka ribuan
				if(ribuan){
					separator = sisa ? '.' : ''
					rupiah += separator + ribuan.join('.')
				}
	 
				rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah
				return prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '')
			}
			
			return angka
		},
	}
}